import React from 'react';
import styled from '@emotion/styled';
import { Box, Button, Text } from '@chakra-ui/react';
import { NavBackIcon } from '../static/icons';

const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1024px;
  margin: auto;
  min-height: 100vh;
  justify-content: center;
`;

const HeaderStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 64px;
  min-height: 64px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 12px 16px;
  }
`;

const PageContainerStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: ${({ theme }) => theme.colors.paper};
  border-radius: 20px;
  flex: 1;
  padding: 16px 64px;
  margin-bottom: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 16px;
    margin-bottom: 0;
  }
`;

interface PageProps {
  onBackClick?: () => void;
  title?: React.ReactChild;
}

export const Page: React.FC<PageProps> = ({ title, children, onBackClick }) => (
  <ContainerStyled>
    <HeaderStyled>
      {!!onBackClick && (
        <Button
          p={0}
          ml={-2}
          mr={2}
          iconSpacing={0}
          variant="ghost"
          leftIcon={<NavBackIcon />}
          onClick={onBackClick}
        />
      )}
      {!!title && (
        <Text as="div" textStyle="h4" align="center" width="100%">
          {title}
        </Text>
      )}
      {!!onBackClick && !!title && <Box w={10} h={10} ml={2} />}
    </HeaderStyled>

    <PageContainerStyled>{children}</PageContainerStyled>
  </ContainerStyled>
);
